import {
  SET_MENU,
  SET_MENU_OPEN_KEYS,
  TOGGLE_MENU,
} from '../../state/actionTypes';

const initialState = {
  items: [],
  openKeys: [],
  isMenuOpen: true,
};

export default function menuActions(state = initialState, action) {
  switch (action.type) {
    case SET_MENU:
      return {
        ...state,
        items: action.payload.items,
      };
    case SET_MENU_OPEN_KEYS:
      return {
        ...state,
        openKeys: action.payload.openKeys,
      };
    case TOGGLE_MENU: {
      const newIsMenuOpen = action.payload.newStatus ?? !state.isMenuOpen;
      window.localStorage.setItem('isMenuOpen', newIsMenuOpen);

      const newState = {
        ...state,
        isMenuOpen: newIsMenuOpen,
      };

      if (!newIsMenuOpen) {
        newState.items = [];
        newState.openKeys = [];
      }

      return newState;
    }
    default:
      return state;
  }
}
